import React, { useState, useEffect } from 'react';
import { getApi } from '../services/apiServices';
import { useLanguage } from '../contexts/LanguageContext';
import { useTranslation } from 'react-i18next';

function DataCalculator() {
  const { t } = useTranslation();
  const { currentLanguage } = useLanguage();

  return (
    <>
 <section className="faq terms-nd-condition">
   <div className='container'>
  <h2>{t('dataCalculator.title')}</h2>
  <p>
    {t('dataCalculator.description')}
  </p>

  <h3 className='inner-heading' style={{ textAlign: "left" ,marin: '0', }}>{t('dataCalculator.usageEstimates.title')}</h3>
  <ul className='terms-list'>
    <li><strong>{t('dataCalculator.usageEstimates.emails')}:</strong> {t('dataCalculator.usageEstimates.emailsAmount')}</li>
    <li><strong>{t('dataCalculator.usageEstimates.maps')}:</strong> {t('dataCalculator.usageEstimates.mapsAmount')}</li>
    <li><strong>{t('dataCalculator.usageEstimates.socialMedia')}:</strong> {t('dataCalculator.usageEstimates.socialMediaAmount')}</li>
    <li><strong>{t('dataCalculator.usageEstimates.videoStreaming')}:</strong> {t('dataCalculator.usageEstimates.videoStreamingAmount')}</li>
    <li><strong>{t('dataCalculator.usageEstimates.musicStreaming')}:</strong> {t('dataCalculator.usageEstimates.musicStreamingAmount')}</li>
    <li><strong>{t('dataCalculator.usageEstimates.videoCalls')}:</strong> {t('dataCalculator.usageEstimates.videoCallsAmount')}</li>
  </ul>

  <h3 className='inner-heading' style={{ textAlign: "left" ,marin: '0', }}>{t('dataCalculator.example.title')}</h3>
  <p dangerouslySetInnerHTML={{ __html: t('dataCalculator.example.description') }} />

  <p>
    {t('dataCalculator.conclusion')}
  </p>
  </div>
</section>



    </>
  );
}

export default DataCalculator;
